import {
  type MultimodalReferenceKind,
  getMultimodalReferenceLabel,
  getMultimodalReferenceToken,
} from '@/ai/references/multimodal-reference-placeholder';
import type {
  WorkspaceReferenceImage,
  WorkspaceReferenceMedia,
} from '../contracts/runtime-state';

export type WorkspaceMentionReference = {
  id: string;
  kind: MultimodalReferenceKind;
  kindIndex: number;
  label: string;
  token: string;
  previewUrl: string | null;
  uploadStatus: 'uploading' | 'uploaded' | 'failed';
  inputUrl: string | null;
};

function makeReference(params: {
  id: string;
  kind: MultimodalReferenceKind;
  kindIndex: number;
  previewUrl: string | null;
  uploadStatus: WorkspaceMentionReference['uploadStatus'];
  inputUrl: string | null;
}): WorkspaceMentionReference {
  return {
    ...params,
    label: getMultimodalReferenceLabel(params.kind, params.kindIndex),
    token: getMultimodalReferenceToken(params.kind, params.kindIndex),
  };
}

export function buildWorkspaceMentionReferences(params: {
  images: WorkspaceReferenceImage[];
  media: WorkspaceReferenceMedia[];
}) {
  const images = params.images
    .filter((item) => !item.isEmpty)
    .map((item, kindIndex) =>
      makeReference({
        id: item.id,
        kind: 'image',
        kindIndex,
        previewUrl: item.previewUrl,
        uploadStatus: item.uploadStatus,
        inputUrl: item.inputUrl,
      })
    );
  const videos = params.media
    .filter((item) => item.kind === 'video')
    .map((item, kindIndex) =>
      makeReference({
        id: item.id,
        kind: 'video',
        kindIndex,
        previewUrl: item.previewUrl,
        uploadStatus: item.uploadStatus,
        inputUrl: item.inputUrl,
      })
    );
  const audio = params.media
    .filter((item) => item.kind === 'audio')
    .map((item, kindIndex) =>
      makeReference({
        id: item.id,
        kind: 'audio',
        kindIndex,
        previewUrl: item.previewUrl,
        uploadStatus: item.uploadStatus,
        inputUrl: item.inputUrl,
      })
    );
  return [...images, ...videos, ...audio];
}
